import React from 'react'
import { DataGrid, GridColDef } from '@material-ui/data-grid';
import { Container } from '@material-ui/core';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { useAccount } from 'hooks/use-account';
import { Typography, IconButton } from '@material-ui/core';
import { Chat } from 'components/organisms/chat';
import { MakeRoom } from 'components/organisms/make-room';
import EnterToAppIcon from '@material-ui/icons/ExitToApp';
import CreateNewIcon from '@material-ui/icons/CreateNewFolder';
import { useRoomList } from 'hooks/use-room-list';
import { useHistory } from 'react-router-dom';
import { Routing } from './routes';
import { useModal } from 'hooks/use-modal';
import { buildPathWithId } from 'utils/path';

const useStyles = makeStyles((theme: Theme) => ({
  grid: {
    marginTop: theme.spacing(2),
    height: '300px',
  },
  new: {
    textAlign: 'right',
    position: 'absolute',
    right: 0,
  },
}));

export const Home: React.FC = () => {
  const classes = useStyles();
  const { name } = useAccount();
  const { roomList } = useRoomList();
  const { push } = useHistory();
  const { Modal, open } = useModal(false); 

  const columns: GridColDef[] = [
    { field: 'name', headerName: 'へや名', width: 260 },
    /*{ field: 'members.length', headerName: '人数', width: 10 },*/
    {
      field: 'id', headerName: 'go', width: 130, renderCell: (cell) => {
        return (
          <IconButton color="inherit" 
                      onClick={() => { enterRoom(cell.value?.toString() || ''); }}>
            <EnterToAppIcon />
          </IconButton>
        );
      }
    },
  ];

  const enterRoom = (id: string) =>{
    if (id) {
      push(buildPathWithId(Routing.RoomPath, id));
    }
  }

  return (<>
    <Typography variant="h6">{`ようこそ${name}たん`}
      <IconButton className={classes.new} color="inherit"  onClick={open}> <CreateNewIcon /> </IconButton>
    </Typography>

    <DataGrid
      className={classes.grid}
      columns={columns}
      rows={roomList}/>

    <Container maxWidth="xs">
      <Chat/>
    </Container>

    <Modal>
      <MakeRoom/>
    </Modal>
  </>);
};
